import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SpecListMinimal } from "@/types/specList";
import { TypeSelectionStep } from "./TypeSelectionStep";
import { DerivedSpecListForm } from "./DerivedSpecListFlow";
import { CustomSpecListForm } from "./CustomSpecListFlow";

type CreateSpecListDialogProps = {
  maskId: string;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  refetchSpecListsData: () => void;
  specLists: SpecListMinimal[];
};

export function CreateSpecListDialog({
  maskId,
  onOpenChange,
  open,
  refetchSpecListsData,
  specLists,
}: CreateSpecListDialogProps) {
  const [choice, setChoice] = useState<"" | "custom" | "derived">("");

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        onOpenChange(open);
      }}
    >
      <DialogContent className="md:max-w-[80%] lg:w-[90%] lg:max-w-[1400px]">
        <DialogHeader className="shrink-0">
          <DialogTitle>Create New Project Spec List</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {choice === ""
            ? "Choose how you want to create your spec list"
            : choice === "derived"
              ? "Create a new Project Spec List based on a Master Version"
              : "Create a custom spec list by uploading a CSV file"}
        </DialogDescription>
        <div className="flex-1 overflow-hidden">
          {choice === "" ? (
            <TypeSelectionStep setChoice={setChoice} onOpenChange={onOpenChange} />
          ) : null}
          {choice === "custom" ? (
            <CustomSpecListForm
              maskId={maskId}
              onOpenChange={onOpenChange}
              refetchSpecListsData={refetchSpecListsData}
              setChoice={setChoice}
            />
          ) : null}
          {choice === "derived" ? (
            <DerivedSpecListForm
              maskId={maskId}
              onOpenChange={onOpenChange}
              refetchSpecListsData={refetchSpecListsData}
              setChoice={setChoice}
              specLists={specLists}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
